import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { InspectionPoint, InspectionFolder, Inspection, InspectionSection } from '../../models/index';

import * as _ from 'lodash';
import { Subject } from 'rxjs';

@Component({
    selector: 'point-list-table',
    templateUrl: './list.component.html',
    standalone: false
})
export class InspectionPointListComponent implements OnInit {
  @Input() public points: InspectionPoint[];
  @Input() public folders: InspectionFolder[];
  @Input() public inspection: Inspection;
  @Input() public updateSubject: Subject<any>;
  partsByPointId: any = [];
  public selectable: Boolean = true;

  @Output() public toggleOpenPoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleOpenFolder: EventEmitter<any> = new EventEmitter();

  @Output() public toggleSelectPoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleSelectFolder: EventEmitter<any> = new EventEmitter();

  public selection: any = {};
  errorMessage: string;
  orderByFieldName = 'order';
  direction = 'asc';
  @Input() query = '';
  public loading: Boolean = true;
  // temporary
  public allItems: any = [];

  public allItemsOrdersById: any = {};

  constructor() {}

  ngOnInit(): void {
    this.initData();
    if (this.updateSubject) this.updateSubject.subscribe((data) => this.initData());
  }

  initData() {
    this.allItems = [];
    if (
      this.inspection &&
      this.inspection.parts &&
      this.inspection.parts.config &&
      this.inspection.parts.config.Parts
    ) {
      const parts = _.filter(this.inspection.parts.config.Parts, (p: any) => p.PointId);
      _.forEach(parts, (part) => {
        this.partsByPointId[part.PointId] = part;
      });
    }
    _.each(this.folders, (f: InspectionFolder) => {
      this.allItems.push(f);
    });

    _.each(this.points, (p: InspectionPoint) => {
      this.allItems.push(p);
    });

    // item.order and folder.order are not always correct (can start at a random int)
    // but section.order is correct
    _.orderBy(this.allItems, 'order', 'asc').forEach((item: InspectionPoint | InspectionFolder, i: number) => {
      const folderOrder = this.getFolderOrder((item as InspectionPoint).folder);
      this.allItemsOrdersById[item.id] = `${item.section.order}.${folderOrder}${i + 1}.`;
    });    
  }

  private getFolderOrder(folder: InspectionFolder): string {
    if (!folder || !folder.section) {
      return '';
    }
    let sectionPoints = folder.section.points ? _.filter(folder.section.points, (p: InspectionPoint) => this.isRootPoint(p, folder.section)) : [];
    let sectionFolders = folder.section.folders ? folder.section.folders : [];
    let allItemsInSection = [...sectionPoints, ...sectionFolders];
    allItemsInSection = _.orderBy(allItemsInSection, 'order', 'asc');
    let orderIndex = allItemsInSection.findIndex((item) => item.id === folder.id);
    if (orderIndex === -1) {
      return '';
    }
    return (orderIndex + 1) + '.';
  }

  isRootPoint(p: InspectionPoint, section: InspectionSection) {
    if (!p.folderId || p.folderId === 'undefined') return true;
    if (!section.inspection.foldersById[p.folderId]) return true;
    return false;
  }

  public selectPoint(e: any, point: any) {
    e.stopPropagation();
    this.toggleSelectPoint.emit(point);
  }

  public selectFolder(e: any, folder: any) {
    e.stopPropagation();
    this.toggleSelectFolder.emit(folder);
  }

  public openPoint(point: InspectionPoint) {
    this.toggleOpenPoint.emit(point);
  }

  public openFolder(folder: InspectionFolder) {
    this.toggleOpenFolder.emit(folder);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }

  public isCriticaly(point: InspectionPoint) {
    if (!point || !point.plugins || point.plugins.length === 0) return false;
    let statesPlugin = _.find(point.plugins, (p: any) => p.pluginType.toLowerCase() === 'states');
    if (!statesPlugin) return false;
    return statesPlugin.config != null && statesPlugin.config.Criticaly;
  }
}

@Component({
  selector: 'point-list-with-date-table',
  templateUrl: './list-with-date.component.html',
  standalone: false
})
export class InspectionPointListWithDateComponent extends InspectionPointListComponent {}
